import { AlertTriangle } from 'lucide-react';
import { UnbilledPhoneNumber } from '@/types/auth/auth';

interface UnbilledPhoneNumbersNoticeProps {
  numbers: UnbilledPhoneNumber[] | undefined;
}

export const UnbilledPhoneNumbersNotice = ({ numbers }: UnbilledPhoneNumbersNoticeProps) => {
  if (!numbers?.length) return null;

  return (
    <div className="rounded-[10px] border border-genie-accent/40 bg-genie-accent/10 p-5">
      <div className="flex items-center gap-2 mb-2">
        <AlertTriangle className="h-5 w-5 text-genie-accent-dark" />
        <h2 className="text-base font-semibold text-gray-900 m-0">
          {numbers.length === 1 ? '1 phone number is' : `${numbers.length} phone numbers are`} not billed
        </h2>
      </div>
      <p className="text-sm text-gray-700 mb-4">
        This account is on a paid plan, but these numbers have no phone subscription in Stripe. They were most likely
        added during a trial, so we are paying for them and the customer isn't.
      </p>
      <ul className="space-y-2">
        {numbers.map((number) => (
          <li
            key={number.id}
            className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 rounded-lg bg-white border border-genie-accent/30 px-3 py-2"
          >
            <div className="min-w-0">
              <div className="font-medium text-gray-900">{number.phone_number}</div>
              {number.agent_name && <div className="text-xs text-gray-500 truncate">{number.agent_name}</div>}
            </div>
            <span className="text-xs text-gray-500 shrink-0">
              Added {new Date(number.date_created).toLocaleDateString()}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
